import React, { useContext } from 'react';
import { usePriceAlertModal } from './PriceAlertModalContext';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useGuestGuideTelemetry } from './GuestGuideTelemetry';
import { AnalyticsContext } from '@shared/core';
import { PriceAlertModal } from '@shared/components/PriceAlertModal/PriceAlertModal.lazy';
import { useTravelAlertSubscriptionStatus } from '@shared/components/PriceAlertModal/useTravelAlertSubscriptionStatus';

const CUSTOM_OFFSET = { x: 16, y: 38 } as const;

export const PriceAlertModalWrapper: React.FC = () => {
  const { isOpen, onClose } = usePriceAlertModal();
  const { eventInfo } = useEventInfo();
  const telemetry = useGuestGuideTelemetry();
  const { anonymousId } = useContext(AnalyticsContext);

  const eventId = eventInfo?.eventId;

  const { existingSubscription } = useTravelAlertSubscriptionStatus({
    eventId,
    anonymousId,
    skip: !isOpen,
  });

  if (!isOpen || !eventId) {
    return null;
  }

  return (
    <PriceAlertModal
      isOpen={isOpen}
      onClose={onClose}
      eventId={eventId}
      source="GUEST_GUIDE"
      telemetry={telemetry}
      existingSubscription={existingSubscription}
      customOffset={CUSTOM_OFFSET}
    />
  );
};
